import { DocumentCaptureError } from './DocumentCaptureError';

class RetrieveConfirmationSaleError extends DocumentCaptureError {
  constructor(message: string, title: string = 'Retrieve Confirmation Sale Error') {
    super(message);
    this.name = 'RetrieveConfirmationSaleError';
    this.title = title;

    // This line is needed to fix the stack trace (which is off by default)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RetrieveConfirmationSaleError);
    }
  }
}

export { RetrieveConfirmationSaleError };
